module.exports = __webpack_public_path__ + "static/assets/c51f0c290bc0661752b638aa185fd8e0.svg";